/*
  PulloraX - image hover zoom helper, magazine lightbox, download deterrent.
  The lightbox runs only on magazine / blog / article templates (data-template on the script tag).
*/
(function () {
  'use strict';

  var script = document.currentScript;
  var template = ((script && script.dataset.template) || '').toLowerCase();
  var lightboxOn = /magazine|article|blog/.test(template);

  var lightboxOnly = script && script.dataset.lightboxOnly === 'true';

  /* ---------- 3. Download deterrent ---------- */
  if (!lightboxOnly) {
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if ((t && t.tagName === 'IMG') || (t && t.closest && t.closest('.px-lb'))) e.preventDefault();
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  }, true);

  /* ---------- 1. Hover zoom: skip icons and tiny images ---------- */
  // 16 Oct 2026 (speed): every width is read first and the classes are added afterwards.
  // Reading a width right after adding a class forced a full page layout per photo
  // (the home page has a few hundred) - about 4 s of a phone's main thread. Same result.
  function markSmall() {
    var imgs = document.querySelectorAll('#MainContent img'), mark = [], i;
    for (i = 0; i < imgs.length; i++) {
      var w = imgs[i].getBoundingClientRect().width;
      if (w && w < 80) mark.push(imgs[i]);
      // QA 9 Oct 2026: no hover zoom when the file is too small to be shown 1.1x without upscaling.
      else if (w && imgs[i].naturalWidth && imgs[i].naturalWidth < w * 1.1) mark.push(imgs[i]);
    }
    for (i = 0; i < mark.length; i++) mark[i].classList.add('px-nozoom');
  }
  window.addEventListener('load', markSmall);
  }

  if (!lightboxOn) return;

  /* ---------- 2. Lightbox ---------- */
  var main = document.getElementById('MainContent');
  if (!main) return;

  var rtl = document.documentElement.getAttribute('dir') === 'rtl';
  var he = (document.documentElement.lang || '').toLowerCase().indexOf('he') === 0;
  var L = he
    ? { close: '\u05e1\u05d2\u05d9\u05e8\u05d4', prev: '\u05ea\u05de\u05d5\u05e0\u05d4 \u05e7\u05d5\u05d3\u05de\u05ea', next: '\u05ea\u05de\u05d5\u05e0\u05d4 \u05d4\u05d1\u05d0\u05d4', dialog: '\u05ea\u05de\u05d5\u05e0\u05d4 \u05de\u05d5\u05d2\u05d3\u05dc\u05ea' }
    : { close: 'Close', prev: 'Previous image', next: 'Next image', dialog: 'Enlarged image' };

  if ((document.documentElement.lang || '').toLowerCase().slice(0, 2) === 'it') L = { close: 'Chiudi', prev: 'Immagine precedente', next: 'Immagine successiva', dialog: 'Immagine ingrandita' };
  var X = window.PXT;
  if (X) L = { close: X.close || L.close, prev: X.prev_image || L.prev, next: X.next_image || L.next, dialog: X.enlarged_image || L.dialog };

  function eligible(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.closest('a, button')) return false; // linked images keep navigating
    return img.matches('.pxm-gcard img, .pxm-cardimg img') || img.getBoundingClientRect().width >= 120;
  }

  function bestSrc(img) {
    var ss = img.getAttribute('srcset');
    if (ss) {
      var best = null, bw = 0;
      ss.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var w = parseInt(bits[1], 10) || 0;
        if (bits[0] && w >= bw) { bw = w; best = bits[0]; }
      });
      if (best) return best;
    }
    return (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=2000');
  }

  var box, bigImg, btnClose, btnPrev, btnNext, counter, gallery = [], index = 0, lastFocus = null, touchX = null;

  function build() {
    box = document.createElement('div');
    box.className = 'px-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', L.dialog);

    bigImg = document.createElement('img');
    bigImg.className = 'px-lb__img';
    bigImg.setAttribute('draggable', 'false');
    bigImg.alt = '';

    btnClose = makeBtn('px-lb__close', L.close, '\u00d7');
    btnPrev = makeBtn('px-lb__prev', L.prev, rtl ? '\u203a' : '\u2039');
    btnNext = makeBtn('px-lb__next', L.next, rtl ? '\u2039' : '\u203a');

    counter = document.createElement('div');
    counter.className = 'px-lb__count';
    counter.setAttribute('aria-live', 'polite');

    box.appendChild(bigImg);
    box.appendChild(btnPrev);
    box.appendChild(btnNext);
    box.appendChild(btnClose);
    box.appendChild(counter);
    document.body.appendChild(box);

    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    box.addEventListener('click', function (e) { if (e.target === box || e.target === bigImg) close(); });
    box.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 50) return;
      var forward = dx < 0;
      if (rtl) forward = !forward;
      go(forward ? 1 : -1);
    });
  }

  function makeBtn(cls, label, glyph) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'px-lb__btn ' + cls;
    b.setAttribute('aria-label', label);
    b.textContent = glyph;
    return b;
  }

  function show() {
    var img = gallery[index];
    bigImg.src = bestSrc(img);
    bigImg.alt = img.alt || '';
    var many = gallery.length > 1;
    btnPrev.hidden = !many;
    btnNext.hidden = !many;
    counter.textContent = many ? (index + 1) + ' / ' + gallery.length : '';
  }

  function go(step) {
    if (gallery.length < 2) return;
    index = (index + step + gallery.length) % gallery.length;
    show();
  }

  function open(img) {
    if (!box) build();
    gallery = Array.prototype.filter.call(main.querySelectorAll('img'), eligible);
    index = Math.max(0, gallery.indexOf(img));
    lastFocus = document.activeElement;
    show();
    document.documentElement.classList.add('px-lb-lock');
    box.classList.add('is-open');
    btnClose.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    box.classList.remove('is-open');
    document.documentElement.classList.remove('px-lb-lock');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowRight') go(rtl ? -1 : 1);
    if (e.key === 'ArrowLeft') go(rtl ? 1 : -1);
    if (e.key === 'Tab') {
      var f = [btnPrev, btnNext, btnClose].filter(function (b) { return !b.hidden; });
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      var n = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i + 1) % f.length;
      f[n].focus();
    }
  }

  function imageFromTarget(target) {
    if (!target || !target.closest || target.closest('a, button')) return null;
    if (eligible(target)) return target;
    var card = target.closest('.pxm-gcard, .pxm-cardimg');
    var img = card && card.querySelector('img');
    return eligible(img) ? img : null;
  }

  main.querySelectorAll('.pxm-gcard img, .pxm-cardimg img').forEach(function (img) {
    if (!eligible(img)) return;
    img.classList.add('px-lb-able');
    img.setAttribute('role', 'button');
    img.setAttribute('tabindex', '0');
    img.setAttribute('aria-haspopup', 'dialog');
  });

  // The existing swipe cue is also a next-image control when the strip overflows.
  var scroller = main.querySelector('#pxm-hits-scroller');
  var cue = main.querySelector('.pxm-hits__cue');
  if (scroller && cue) {
    var hits = Array.prototype.slice.call(scroller.querySelectorAll('.pxm-hit'));
    var dots = main.querySelectorAll('#pxm-hits-dots i');
    var hitIndex = main.querySelector('#pxm-hits-idx');
    function nearestHit() {
      var edge = scroller.getBoundingClientRect();
      var best = 0, distance = Infinity;
      hits.forEach(function (hit, i) {
        var rect = hit.getBoundingClientRect();
        var d = Math.abs(rtl ? rect.right - edge.right : rect.left - edge.left);
        if (d < distance) { distance = d; best = i; }
      });
      return best;
    }
    function updateCue() {
      var overflow = scroller.scrollWidth > scroller.clientWidth + 1 && hits.length > 1;
      if (overflow) {
        cue.removeAttribute('aria-hidden');
        cue.setAttribute('role', 'button');
        cue.setAttribute('tabindex', '0');
        cue.setAttribute('aria-label', L.next);
      } else {
        cue.setAttribute('aria-hidden', 'true');
        cue.removeAttribute('role');
        cue.removeAttribute('tabindex');
        cue.removeAttribute('aria-label');
      }
      var active = nearestHit();
      dots.forEach(function (dot, i) { dot.classList.toggle('on', i === active); });
      if (hitIndex) hitIndex.textContent = active + 1;
    }
    function nextHit() {
      if (cue.getAttribute('role') !== 'button') return;
      var target = hits[(nearestHit() + 1) % hits.length].getBoundingClientRect();
      var edge = scroller.getBoundingClientRect();
      var delta = rtl ? target.right - edge.right : target.left - edge.left;
      scroller.scrollBy({
        left: delta,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    cue.addEventListener('click', nextHit);
    cue.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); nextHit(); }
    });
    scroller.addEventListener('scroll', updateCue, { passive: true });
    window.addEventListener('resize', updateCue);
    updateCue();
  }

  main.addEventListener('mouseover', function (e) {
    var img = imageFromTarget(e.target);
    if (img) img.classList.add('px-lb-able');
  });
  main.addEventListener('click', function (e) {
    var img = imageFromTarget(e.target);
    if (img) { e.preventDefault(); open(img); }
  });
  main.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var img = imageFromTarget(e.target);
    if (img && img.getAttribute('role') === 'button') {
      e.preventDefault();
      open(img);
    }
  });
})();
